/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const RECALCULATE_GIFT_CARD_TOTAL = 'MFE/CHECKOUT/RECALCULATE_GIFT_CARD_TOTAL';
export const RECALCULATE_GIFT_CART_TOTAL_COMPLETED = 'MFE/CHECKOUT/RECALCULATE/GIFT/CARD/TOTAL/COMPLETED';
export const APPLY_GIFT_CARD_ACTION = 'MFE/CHECKOUT/APPLY/GIFTCARD';
export const REMOVE_GIFT_CARD_ACTION = 'MFE/CHECKOUT/REMOVE/GIFTCARD';
export const APPLY_GIFT_CARD_PROCESS_COMPLETED = 'MFE/CHECKOUT/APPLY_GIFT_CARD_PROCESS_COMPLETED';
export const REMOVE_GIFT_CARD_PROCESS_COMPLETED = 'MFE/CHECKOUT/REMOVE_GIFT_CARD_PROCESS_COMPLETED';

export default {};
